export default "__VITE_ASSET__R46U3wi5__"